import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CONSENT_KEY, initPixels } from "@/lib/pixels";

// Bandeau de consentement cookies (RGPD / ePrivacy). Les pixels publicitaires
// (Meta, Google, TikTok) ne se déclenchent QUE si l'utilisateur a accepté.
export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const v = localStorage.getItem(CONSENT_KEY);
      if (!v) setVisible(true);
    } catch (e) {
      setVisible(true);
    }
  }, []);

  const choose = (val) => {
    try {
      localStorage.setItem(CONSENT_KEY, val);
    } catch (e) {
      /* stockage indisponible : on ignore */
    }
    setVisible(false);
    if (val === "accepted") initPixels();
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent"
      className="fixed inset-x-0 bottom-0 z-[100] px-3 pb-3 sm:px-6 sm:pb-4"
    >
      <div className="mx-auto flex max-w-3xl flex-col gap-3 rounded-2xl border border-neutral-200 bg-white p-3.5 shadow-2xl sm:flex-row sm:items-center sm:gap-5 sm:p-4">
        <p className="text-xs leading-relaxed text-neutral-600 sm:text-sm">
          <span className="font-bold text-neutral-900">🍪 Cookies : </span>
          {"mesure d'audience et publicité (Meta, Google, TikTok), uniquement avec ton accord. "}
          <Link to="/confidentialite" className="font-semibold text-brand underline underline-offset-2">En savoir plus</Link>
        </p>
        <div className="flex shrink-0 gap-2">
          <button
            onClick={() => choose("refused")}
            data-testid="cookie-reject-btn"
            className="flex-1 rounded-lg border border-neutral-300 px-4 py-2 text-sm font-semibold text-neutral-700 hover:bg-neutral-50 sm:flex-none"
          >
            Refuser
          </button>
          <button
            onClick={() => choose("accepted")}
            data-testid="cookie-accept-btn"
            className="flex-1 rounded-lg bg-brand px-4 py-2 text-sm font-semibold text-white hover:opacity-90 sm:flex-none"
          >
            Accepter
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;
